import React from 'react';
import styled from 'styled-components/macro';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { FlexItem } from '@as_core/elements/flexStyles';
import { DocumentIconLink } from '@as_core/styles/elementStyles';

import {
  getFeatureTagIcon,
  getFeatureTagLabel,
  getAllFeatures,
} from './ResourceTypeTiles/utils';

interface PropsI {
  subApp: string;
  queryFeature: string;
}
const debug = false;
const SearchIcons = ({subApp, queryFeature}: PropsI) => {
  const navigate = useNavigate();
  const allFeatureTags = getAllFeatures(subApp);
  if (debug) console.log(`SearchIcons: subApp: ${subApp} queryFeature: ${queryFeature}, allFeatureTags:`, allFeatureTags);
  return (
    <IconContainer>
      {allFeatureTags.map((tag, index) => (
        <FlexItem key={`feature_icon_${index}`}>
          <Tooltip
            key={`search_videos`}
            title={`Show all available for ${getFeatureTagLabel(tag)}`}
            placement={'bottom-start'}
            arrow
          >
            <DocumentIconLink
              onClick={() => navigate(`/help?feature=${tag}`)}
              isActive={ queryFeature === tag }
            >
              {getFeatureTagIcon(tag)}
            </DocumentIconLink>
          </Tooltip>
        </FlexItem>
      ))}
    </IconContainer>
  );
}

export default SearchIcons;

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: max-content;
`